import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/mkt-loyalty-points/history';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export interface GetMyAccountPointsHistorySuccessResponse {
    data : paths[url]['get']['responses']['200']['content']['application/json'];
} 

/**
 * Requests endpoint to get all addresses.
 * Then saves it in Data Context.
 */
export const useGetMyAccountPointsHistory = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setMyPoints } = useData();

    const request = async () => {
        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetMyAccountPointsHistorySuccessResponse = await response.json();

            setMyPoints(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        }
    };

    return { request };
};
